import { COLOR_PALETTE } from 'constants/ui';

export const callHistoryContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  backgroundColor: ({ palette }) => palette.background.secondary,
};

export const filterRowStyles = {
  display: 'flex',
  gap: '6px',
  padding: '12px 16px',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  flexShrink: 0,
};

export const filterChipStyles = {
  fontSize: '12px',
  fontWeight: 500,
  padding: '4px 12px',
  borderRadius: '16px',
  cursor: 'pointer',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  backgroundColor: ({ palette }) => palette.background.paper,
  color: ({ palette }) => palette.text.secondary,
  transition: 'all 0.15s',
  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.disabled,
  },
};

export const filterChipActiveStyles = {
  ...filterChipStyles,
  backgroundColor: COLOR_PALETTE.BRAND[1],
  borderColor: COLOR_PALETTE.BRAND[5],
  color: COLOR_PALETTE.BRAND[7],
  '&:hover': {
    backgroundColor: COLOR_PALETTE.BRAND[2],
  },
};

export const historyListStyles = {
  flex: 1,
  overflow: 'auto',
};

export const historyRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '10px 16px',
  cursor: 'pointer',
  transition: 'background-color 0.15s',
  borderBottom: ({ palette }) => `1px solid ${palette.border.light}`,
  height: '100%',
  overflow: 'hidden',
  boxSizing: 'border-box',
  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.disabled,
  },
};

const directionIconStyles = {
  fontSize: 20,
  flexShrink: 0,
};

export const inboundIconStyles = {
  ...directionIconStyles,
  color: COLOR_PALETTE.GREEN[7],
};

export const outboundIconStyles = {
  ...directionIconStyles,
  color: COLOR_PALETTE.BRAND[6],
};

export const missedIconStyles = {
  ...directionIconStyles,
  color: COLOR_PALETTE.RED[6],
};

export const historyInfoStyles = {
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  flex: 1,
};

export const historyNameStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: ({ palette }) => palette.text.strong,
};

export const historyMissedNameStyles = {
  ...historyNameStyles,
  color: COLOR_PALETTE.RED[6],
};

export const historyDetailStyles = {
  color: ({ palette }) => palette.text.placeholder,
};

export const historyTimeStyles = {
  flexShrink: 0,
  textAlign: 'right',
  color: ({ palette }) => palette.text.placeholder,
};

export const emptyStateStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  padding: '24px',
  gap: '8px',
};

export const emptyStateIconStyles = {
  color: ({ palette }) => palette.text.disabled,
};

export const emptyStateTextStyles = {
  textAlign: 'center',
  color: ({ palette }) => palette.text.placeholder,
};

export const loadingContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
};
